export const AMPLITUDE_API_KEY = 'e661f78accdbf735faa669169da0eb22'
